import React from 'react';

import i18n from '@nextroll/ar-i18n';
import { Popper, Tooltip } from '@nextroll/ar-style-base';

import { IWorkflow, WorkflowBaseType, WORKFLOW_BASE } from 'types/rofl';
import { formatLastEnrollmentAge, workflowHasNotRun } from 'util/util';

const WorkflowTableEnrollmentStatsTooltip = ({ base } : { base?: WorkflowBaseType }) => {
    const tooltipContent = (
        <Tooltip className='workflow-table-total-enrolled-tooltip'>
            {base === WORKFLOW_BASE.ACCOUNTS
                ? i18n.gettext('Last time one or more accounts were enrolled into this workflow.')
                : i18n.gettext('Last time one or more contacts were enrolled into this workflow.')}
        </Tooltip>
    );

    return (
        <Popper hoverContent={tooltipContent} breakOutOfOverflow>
            <i aria-label='tooltip' className='far fa-info-circle' />
        </Popper>
    );
};

/**
 * Element for displaying enrollment statistics, e.g. Last 25 days ago.
 */
export const WorkflowTableEnrollmentStatsCell = ({ workflow }: { workflow: IWorkflow }) => {
    if (workflowHasNotRun(workflow)) {
        return (
            <>
                {i18n.gettext('N/A')}
                <br />
                <small>
                    {i18n.gettext('Last: N/A')}
                    &nbsp;
                    <WorkflowTableEnrollmentStatsTooltip base={workflow.entity_type} />
                </small>
            </>
        );
    }
    const count = workflow.sum_of_enrolled_entities || 0;
    const time = workflow.latest_enrollment_timestamp;
    return (
        <>
            {workflow.entity_type === WORKFLOW_BASE.ACCOUNTS
                ? i18n.gettext('{{ count }} accounts', { count })
                : i18n.gettext('{{ count }} contacts', { count })}
            <br />
            <small>
                {i18n.gettext('Last:')}
                &nbsp;
                {formatLastEnrollmentAge(time)}
                &nbsp;
                <WorkflowTableEnrollmentStatsTooltip base={workflow.entity_type} />
            </small>
        </>
    );
};
